import * as React from "react";
import { ClientDetails } from "../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { WhatIfToolDetailModel } from "../../../../../../Wrap/Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel";
import { GenderMap } from "../../../../../Shared/Entities/Maps/GenderMap";
import { TitleMap } from "../../../../../Shared/Entities/Maps/TitleMap";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { dateParser } from "../../Common/Review/ReviewParser";

interface IClientDetailsForWhatIfProps extends IProcessComponentProps {
    extraInfo: WhatIfToolDetailModel;
}

interface IClientDetailsForWhatIfState {}

export class ClientDetailsForWhatIf extends ProcessComponent<
    IClientDetailsForWhatIfProps,
    IClientDetailsForWhatIfState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private config = (data: ClientDetails) => [
        {
            title: "Title",
            data: TitleMap.getString(data?.Title),
        },
        {
            title: "First name(s)",
            data: data?.FirstName,
        },
        {
            title: "Surname",
            data: data?.LastName,
        },
        {
            title: "Gender",
            data: GenderMap.getString(data?.Gender),
        },
        {
            title: "Date of birth",
            data: dateParser(data?.DateOfBirth),
        },
    ];

    public render(): JSX.Element {
        return (
            <>
                {this.props.extraInfo?.PrimaryClientDetails && (
                    <>
                        <h2>Client details</h2>
                        <Typography type="wider" config={this.config(this.props.extraInfo?.PrimaryClientDetails)} />
                    </>
                )}
                {this.props.extraInfo?.SecondaryClientDetails && (
                    <>
                        <h2>Client details</h2>
                        <Typography type="wider" config={this.config(this.props.extraInfo?.SecondaryClientDetails)} />
                    </>
                )}
            </>
        );
    }
}
